import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Error.css';

const Unauthorized = () => {
  return (
    <div className="error-container">
      <h1>403</h1>
      <h2>Accès non autorisé</h2>
      <p>Vous n'avez pas les permissions nécessaires pour accéder à cette page.</p>
      <Link to="/" className="btn-primary">
        Retour à l'accueil
      </Link>
    </div>
  );
};

export default Unauthorized;
